var SharedProModule = (function () {
    function SharedProModule() {
    }
    return SharedProModule;
}());
export { SharedProModule };



// WEBPACK FOOTER //
// ./src/component/shareProModule.ts.pre-build-optimizer.js